import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADMIN_PATH, ADMIN_TAB_PATHS, NO_PERMISSION_PATH } from '../../constants/paths.constants';
import { PERMISSIONS } from '../../constants/permissions.constants';
import { currentUserSelector, hasPermission } from '../../selectors/auth.selectors';

export const useAdminRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector(currentUserSelector);

  const permissionNeeded = Object.values(ADMIN_TAB_PATHS).find(
    (tab) => `${ADMIN_PATH}${tab.path}` === location.pathname
  )?.permission;

  if (permissionNeeded && !hasPermission(user, PERMISSIONS.STAD_DISPATCH)) {
    navigate(NO_PERMISSION_PATH);
  }
};
